import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faWallet } from '@fortawesome/free-solid-svg-icons'
import BaseModal from './BaseModal'

const EditBank = () => {
    return (
        <BaseModal modalId="modalEditBank" modalTitle="Edit Bank" modalTitleIcon={faWallet} children={<Child />} />
    )
}

export default EditBank


const Child = () => {
    return(
        <form action="#" method="post" className="text-dark">
            <input type="text" className="form-control" placeholder="NUBAN" />
            <select>
                <option value="GTB" selected>GTB</option>
                <option value="UBA">UBA</option>
                <option value="Access Bank">Access Bank</option>
                <option value="FCMB">FCMB</option>
            </select>
            <button type="submit" className="btn btn-purple shadow-sm w-100 mt-4">Edit <FontAwesomeIcon icon={faCheckCircle} /></button>
        </form>
    )
}